import { useQuery } from "@tanstack/react-query";
import api from "../../../util/api";
import {
  LocationApiType,
  PaginatedResponse,
  QueryKeys,
} from "../../../util/types";

export interface LocationsFilters {
  searchKeyword?: string;
  type?: "shipping" | "terminal";
  ignorePoliciesCheck?: boolean;
}

export const useGetAdvancedSearchLocations = (filters?: LocationsFilters) => {
  const { data, isLoading: loading } = useQuery<
    PaginatedResponse<LocationApiType>
  >({
    queryKey: [
      QueryKeys.ADVANCED_SEARCH_LOCATIONS_LIST,
      filters?.searchKeyword ?? "",
      filters?.type,
    ],
    queryFn: async () =>
      await api.getLocationsList(1, 50, {
        sort: "createdAt",
        sortDirection: "DESC",
        ...filters,
        ignorePoliciesCheck: filters?.ignorePoliciesCheck ?? true,
      }),
    placeholderData: (prev) => prev,
    staleTime: 10 * 60 * 1000,
  });

  return {
    locations: data?.docs ?? [],
    loading,
  };
};
